import React,{useState} from 'react';
import { Container,Row,Col } from 'react-bootstrap';
import './styles/App.css';
import TopTitle from './TopTitle'


function StoreSetting() {

    const [test, setTest] = useState('')
    const [all , setAll] = useState(false);
    const [service , setService] = useState(false);
    const [review , setReview] = useState(false);


    const onClick = () => {
        setAll(!all)   
    }


    return (
        
        <>
        <Container>
            <div className="c_pad mt-5">
                <TopTitle title="설정" />
                <div className="r_flex mb-3">
                    <Col className="p-0">
                        <h3 className="font-weight-bold">버전 정보</h3>
                    </Col>
                    <Col className="p-0 position-relactive">
                        <div className="text-right">
                            <span className="ss_text">version 1.4</span>
                        </div>
                    </Col>
                </div>
            </div>
        </Container>
        <div className="ss_border"></div>
        <Container>
        <div className="c_pad mt-5">
            <div className="r_flex mb-3">
                <Col className="p-0">
                    <h3 className="font-weight-bold mb-5">알림</h3>
                    <div className="pl-3 mb-5 font-weight-bold">전체 서비스 알림</div>
                    <div className="pl-3 font-weight-bold">리뷰 알림</div>
                </Col>
                <Col className="p-0">
                        {
                            test.map(v => 
                                v.total
                                ?
                                <div className="position-relactive ss_wrap mb-5">
                                <span className="d-block ss_active_icon" onClick={onClick} data-name="service" data-value={true}></span>
                                </div>
                                :
                                <>
                                <div className="position-relactive ss_wrap mb-5">
                                <span className="d-block ss_default_icon" onClick={onClick} data-name="service" data-value={true}></span>
                                </div>
                                </>
                                )
                        }
                     {/* 
                    <div className="position-relactive ss_wrap mb-5">
                        {
                            test.map(v => 
                                v.total
                                ?
                                <>
                                <span className="d-block ss_active_icon" onClick={onClick} data-name="service" data-value={true}></span>
                                <span className="d-block ss_active_icon" onClick={onClick} data-name="service" data-value={true}></span>
                                <span className="d-block ss_active_icon" onClick={onClick} data-name="service" data-value={true}></span>
                                </>
                                :
                                <>
                                <span className="d-block ss_default_icon" onClick={onClick} data-name="service" data-value={true}></span>
                                <span className="d-block ss_default_icon" onClick={onClick} data-name="service" data-value={true}></span>
                                <span className="d-block ss_default_icon" onClick={onClick} data-name="service" data-value={true}></span>
                                </>
                                )
                        }
                       
                    {
                        all
                        ?<span className="d-block ss_active_icon" onClick={onClick}></span>
                        :<span className="d-block ss_default_icon" onClick={onClick}></span>
                    }   
                    </div>
                    <div name="service" className="position-relactive ss_wrap mb-5">
                    {
                        all
                        ?<span className="d-block ss_active_icon" onClick={onClick} data-name="service" data-value={true}></span>
                        :<span className="d-block ss_default_icon" onClick={onClick} data-name="service" data-value={false}></span>
                    }   
                    </div>
                    <div name="review" className="position-relactive ss_wrap mb-5">
                    {
                        all
                        ?<span className="d-block ss_active_icon" onClick={onClick} data-name="review" data-value={true}></span>
                        :<span className="d-block ss_default_icon" onClick={onClick} data-name="review" data-value={false}></span>
                    }
                      
                    </div>
                    */} 
                     
                </Col>
            </div>
        </div>
        </Container>
        </>
    );
}

export default StoreSetting;